import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import useColors from "../../../../../../../api/hooks/useColors";
import SvgToIcon from "../../../../../../../icons/SvgToIcon";
import { icons } from "../../../../icons/iconExport";
import slaChartImg from "./sla_chart.svg";

export const NoDataMessage = () => {
  const colors = useColors();
  return (
    <Box sx={{ position: "relative", width: "100%", height: "350px" }}>
      <Box
        component="img"
        src={slaChartImg}
        sx={{
          width: "100%",
          height: "350px",
          objectFit: "contain",
          filter: "blur(5px)",
          opacity: 0.2,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          padding: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          borderRadius: 2,
        }}
      >
        <SvgToIcon
          IconLogo={icons.MonitorIcon}
          style={{
            width: "40px",
            height: "40px",
            color: colors.primary_48percent,
          }}
        />
        <Typography
          variant="h6"
          align="center"
          sx={{
            color: colors.text_primary,
            fontWeight: 500,
          }}
        >
          We've started monitoring your environment.
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{
            color: colors.text_secondary,
          }}
        >
          You'll begin seeing SLA performance insights as soon as enough data is
          collected.
        </Typography>
      </Box>
    </Box>
  );
};
